<template>
  <div>
    <page-header
      title="Create Person"
      breadcrumb="Dashboard > Settings > Organization Hierarchy > Create Person"
    />
    <div class="new-person-form-wrapper">
      <div class="new-person-form">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3 col-lg-3 col-3">
              <div class="picture-upload-form text-center">
                <div class="my-3">
                  <image-uploader
                    @input="handleImageUpload($event)"
                    @remove-image="removeImage"
                    :isUploadingImage="isUploadingImage"
                  />
                  <!-- <image-upload
                    @input="handleImageUpload($event)"
                    @remove-image="removeImage"
                    :isUploadingImage="isUploadingImage"
                  /> -->
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-12 col-12">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="fname" class="label">First Name</label>
                      <input
                        type="text"
                        class="input"
                        v-model="newPerson.fname"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="middlename" class="label">Middle Name</label>
                      <input
                        type="text"
                        class="input"
                        v-model="newPerson.middlename"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="lname" class="label">Last Name</label>
                      <input
                        type="text"
                        class="input"
                        v-model="newPerson.lname"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="gender" class="label">Gender</label>
                      <el-select v-model="newPerson.gender" placeholder="">
                        <el-option
                          v-for="gender in genders"
                          :key="gender"
                          :label="gender"
                          :value="gender"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="email" class="label">Work Email</label>
                      <input
                        type="email"
                        class="input"
                        v-model="newPerson.email"
                      />
                    </div>
                  </div>
                  <div class="new-user-form__single-input-wrapper">
                    <label for="number" class="label">Phone Number</label>
                    <vue-tel-input v-model="newPerson.phoneNo"></vue-tel-input>
                  </div>
                  <!-- <div class="col-md-12 col-lg-6 col-12">
                    <div class="new-person-form__single-input-wrapper">
                      <label for="number" class="label">Phone Number</label>
                      <input
                        type="text"
                        class="input"
                        v-model="newPerson.phoneNo"
                        @keypress="isNumber($event)"
                      />
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr" />
      <div class="new-person__advanced-details">
        <p class="font-semibold text-primary-yellow pb-3">Advanced Details</p>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Designation</label>
              <el-select v-model="newPerson.designationId" @change="changeLevel" placeholder="Select">
                <el-option
                  v-for="designation in designations"
                  :key="designation.id"
                  :label="designation.name"
                  :value="designation.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Function</label>
              <el-select v-model="newPerson.functionId" placeholder="Select">
                <el-option
                  v-for="selectedFunction in functions"
                  :key="selectedFunction.id"
                  :label="selectedFunction.name"
                  :value="selectedFunction.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Job Level</label>
              <input type="text" class="input" v-model="levelName" disabled/>

              <!-- <el-select v-model="newPerson.levelId" placeholder="Select">
                <el-option
                  v-for="level in jobLevels"
                  :key="level.id"
                  :label="level.name"
                  :value="level.id"
                >
                </el-option>
              </el-select> -->
            </div>
            <div class="col-md-4 col-lg-4 col-12">
              <label class="label">Reporting To</label>
              <el-select v-model="newPerson.reportingTo" placeholder="Select">
                <el-option
                  v-for="person in people"
                  :key="person.id"
                  :label="
                    person.id ? `${person.fname} ${person.lname}` : 'Nil'
                  "
                  :value="person.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <button
          class="button"
          @click="$router.push({ name: 'OrganizationHierarchy' })"
        >
          Cancel
        </button>
        <primary-button buttonText="save " @click="createPerson" :loading="creatingPerson" :disabled="disableButton"/>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ImageUploader from "@/components/3pl/Users/ImageUploader";

export default {
  components:{
    PageHeader,
    ImageUploader
  },
  data() {
    return {
      // 'fname': 'new tobi',
      // 'lname': 'agbeja',
    //   'dialCode': '234',
    // 'email': 'tobiagbeja@gmail.com',
    // 'orgId': 'b8dbee24-2c80-4cb2-8db6-6cca1e6f91c0',
    // 'phoneNo': '123456789'
      newPerson: {
        fname: "",
        lname: "",
        dialCode: "",
        // gender: "",
        email: "",
        phoneNo: "",
        designationId: "",
        functionId: "",
        levelId: "",
        reportingTo: "",
        imageurl: "",
      },
      //not part of the request just for user sake
      levelName: "",
      // genders: ["Male", "Female"],
      creatingPerson: false,
      functions: [{ name: "Nil", id: null }],
      designations: [{ name: "Nil", id: null}],
      jobLevels: [{ name: "Nil", id: null }],
      people: [{ name: "Nil", id: null }], 
      isUploadingImage: false,
    };
  },
  computed: {
    disableButton() {
      let { fname, lname, email, phoneNo, imageurl } = this.newPerson;
      if (
        fname.length &&
        lname.length &&
         email.length &&
        phoneNo.length &&
        imageurl.length 
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.fetchAllRequiredData();
  },
  methods: {
    async createPerson() {
      this.creatingPerson = true;
      try {
        this.newPerson.dialCode = "234";
        let response = await this.$_createPerson(this.newPerson);
        console.log(response);
        this.generateToast("User successfully created!", "success");
        this.resetInputFields();
        // this.fetchAllRequiredData();
        this.creatingPerson = false;
        this.$router.push({ name: "OrganizationHierarchy" });
      } catch (error) {
        this.handleError(error);
        this.creatingPerson = false;
      }
    },
    async getAllPeople() {
      this.people = [{ name: "Nil", id: null }];
      try {
        let response = await this.$_getAllPeople();
        console.log(response);
        let people = response.data.users;
        this.people = this.people.concat(people);
      } catch (error) {
        this.handleError();
      }
    },
    async getFunctions() {
      this.functions = [{ name: "Nil", id: null }];
      try {
        let response = await this.$_getAllFunctions();
        console.log(response);
        let functions = response.data.functions;
        this.functions = this.functions.concat(functions);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDesignations() {
      this.designations = [{ name: "Nil", id: null }];
      try {
        let response = await this.$_getAllDesignations();
        console.log(response);
        let designations = response.data.designations;
        this.designations = this.designations.concat(designations);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getJobLevels() {
      this.jobLevels = [{ name: "Nil", id: null }];
      try {
        let response = await this.$_getJobLevels();
        console.log(response);
        let jobLevels = response.data.levels;
        this.jobLevels = this.jobLevels.concat(jobLevels);
      } catch (error) {
        this.handleError(error);
      }
    },
    fetchAllRequiredData() {
      this.getFunctions();
      this.getDesignations();
      this.getJobLevels();
      this.getAllPeople();
    },
    changeLevel(e){
      console.log(e, 'event')
      let selectedDesignation = this.designations.find(d => d.id === e)
      if(selectedDesignation.level){
        this.newPerson.levelId = selectedDesignation.levelId
        this.levelName = selectedDesignation.level.name
        // console.log(this.newPerson.levelId, 'new l');
      }
    },
    resetInputFields() {
      this.newPerson = {
        fname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        designationId: "",
        functionId: "",
        levelId: "",
        reportingTo: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newPerson.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newPerson.imageurl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.kpi-input {
  width: 70%;
}

tr:first-child td:first-child {
  border-top-left-radius: 10px;
}
tr:first-child td:last-child {
  border-top-right-radius: 10px;
}
tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}
tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}
.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
